export default __webpack_public_path__ + "static/media/founders-grotesk-test-light.1d7fa85a.woff";